module.exports = __webpack_public_path__ + "img/button diameter.a0b6afa8.png";